import React from "react";
import cx from "classnames";
import { Trans } from "react-i18next";
import { Pagination, PaginationItem, PaginationLink, Label, Input, FormGroup } from "reactstrap";
import { useTableContext } from "../hooks";

export const XeroPagination = ({ table }) => {
  const _table = useTableContext();
  table = table ?? _table;
  const { state, canPreviousPage, canNextPage, previousPage, nextPage, page, setPageSize, gotoPage } =
    table;
  const { pageSize, pageIndex } = state;

  const start = pageSize * pageIndex;
  const end = start + Math.min(pageSize, page.length);

  return (
    <div className="row">
      <div className="col-6">
        <Pagination size="sm">
          <PaginationItem disabled={!canPreviousPage}>
            <PaginationLink previous href="#" onClick={(e) => { e.preventDefault(); previousPage() }} />
          </PaginationItem>
          <PaginationItem disabled={pageIndex === 0}>
            <PaginationLink previous href="#" onClick={(e) => { e.preventDefault(); gotoPage(0) }}>
              0
            </PaginationLink>
          </PaginationItem>
          <PaginationItem disabled={!canPreviousPage}>
            <PaginationLink previous href="#" onClick={(e) => { e.preventDefault(); previousPage() }}>
              ...
            </PaginationLink>
          </PaginationItem>
          {pageIndex !== 0 &&
            <PaginationItem disabled>
              <PaginationLink next href="#">
                {pageIndex}
              </PaginationLink>
            </PaginationItem>
          }
          <PaginationItem disabled={!canNextPage}>
            <PaginationLink next href="#" onClick={(e) => { e.preventDefault(); nextPage() }} />
          </PaginationItem>
        </Pagination>
        <div className={cx("text-muted small")}>
          <Trans>Viewing</Trans> {start} - {end}
        </div>
      </div>
      <div className="col-6 text-right">
        <span className="text-secondary small"><Trans>Items Per Page</Trans>:</span>
        {[25, 50, 100].map((number) => (
          <button className={`btn btn-link link small shadow-none px-1 mx-1 ${pageSize === number ? 'text-muted' : 'text-success'}`} disabled={pageSize === number} onClick={(e) => { setPageSize(number) }}>
            {number}
          </button>
        ))}
      </div>
    </div>
  );
};
